<template>

<app-table empty-message="There are no stacked badge types." :empty="!item.stacked.length">

	<app-table-head :layout="layout">

		<app-table-column text="Type" />

		<app-table-column text="Sale" />

		<app-table-column text="Date" />

		<app-table-column />

	</app-table-head>

	<app-table-body>

		<app-table-row :layout="layout" v-for="stacked in item.stacked" :key="stacked.id">

			<app-table-cell-item type="convention/badge/type" :item="stacked" />

			<app-table-cell-item type="convention/registation/sale" :item="stacked.sale" empty-text="Admin applied." />

			<app-table-cell-text v-if="stacked.sale" :text="stacked.sale.date.made | localDate('MM/DD/YYYY h:mma')" />
			<app-table-cell-text v-if="!stacked.sale" :can-empty="true" />

			<app-table-cell-action v-if="stacked.sale" icon="refund" v-tooltip="'Refund badge'" v-on:click="$emit('remove', stacked)" />
			<app-table-cell-action v-if="!stacked.sale" icon="remove" v-tooltip="'Remove badge'" v-on:click="$emit('remove', stacked)" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['item'],

	data: function() {
	
		return {
			layout: 'auto 240px 160px 40px'
		}
	
	}

}

</script>

<style scoped>

</style>